import { ButtonBase, Typography } from '@mui/material';
import { usePlatformHandoff } from '../../services/platform-handoff';

// The platform's apps mark, duplicated rather than imported: the two apps share no
// package, so the alternative is the two controls not matching. Kept in step with
// `BrandGridIcon` in the platform's src/shell/icons.tsx.
const GridIcon = () => (
  <svg width='30' height='30' viewBox='0 0 18 18' fill='none' aria-hidden='true'>
    <path
      d='M6.375 1.5H3.375C2.33947 1.5 1.5 2.33947 1.5 3.375V6.375C1.5 7.41053 2.33947 8.25 3.375 8.25H6.375C7.41053 8.25 8.25 7.41053 8.25 6.375V3.375C8.25 2.33947 7.41053 1.5 6.375 1.5Z'
      fill='#2F5EFF'
    />
    <path
      opacity='0.65'
      d='M14.625 1.5H11.625C10.5895 1.5 9.75 2.33947 9.75 3.375V6.375C9.75 7.41053 10.5895 8.25 11.625 8.25H14.625C15.6605 8.25 16.5 7.41053 16.5 6.375V3.375C16.5 2.33947 15.6605 1.5 14.625 1.5Z'
      fill='#2F5EFF'
    />
    <path
      opacity='0.45'
      d='M6.375 9.75H3.375C2.33947 9.75 1.5 10.5895 1.5 11.625V14.625C1.5 15.6605 2.33947 16.5 3.375 16.5H6.375C7.41053 16.5 8.25 15.6605 8.25 14.625V11.625C8.25 10.5895 7.41053 9.75 6.375 9.75Z'
      fill='#2F5EFF'
    />
    <path
      opacity='0.25'
      d='M14.625 9.75H11.625C10.5895 9.75 9.75 10.5895 9.75 11.625V14.625C9.75 15.6605 10.5895 16.5 11.625 16.5H14.625C15.6605 16.5 16.5 15.6605 16.5 14.625V11.625C16.5 10.5895 15.6605 9.75 14.625 9.75Z'
      fill='#2F5EFF'
    />
  </svg>
);

// Returns the visitor to the platform's app launcher.
const AllAppsButton = () => {
  const handleClick = usePlatformHandoff();

  return (
    <ButtonBase
      onClick={handleClick}
      aria-label='All apps'
      sx={{
        gap: '10px',
        borderRadius: '8px',
        px: '4px',
        py: '2px',
        whiteSpace: 'nowrap',
      }}
    >
      <GridIcon />
      <Typography
        sx={{
          fontSize: '16px !important',
          fontWeight: 500,
          lineHeight: 1,
          color: 'primary.main',
        }}
      >
        All apps
      </Typography>
    </ButtonBase>
  );
};

export default AllAppsButton;
